// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import { SagaObject } from '../../SagaBase/SagaObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class CProcStep_abstract extends SagaObject {
  static $t: string = 'SagaSchema.CProcStep';
  $t: string = 'SagaSchema.CProcStep';

  public static GetMembers(): string[] {
    return ['ProcedureId', 'HeaderOrder', 'StepGuid', 'SortOrder', 'CallCardId'].concat(SagaObject.GetMembers());
  }

  public GetMembers(): string[] {
    return CProcStep_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ProcedureId: number = 0;
  public HeaderOrder: number = 0;
  public StepGuid: Guid = GuidTools.Empty;
  public SortOrder: number = 0;
  public CallCardId: Guid = GuidTools.Empty;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return this.CallCardId;
  }
  set ParentObjId(value: any) {
    this.CallCardId = value;
  }

  /*</AUTO_IMPLEMENTATION>*/
}
